import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// 1. IMPORTIAMO apiUrl DIRETTAMENTE (perché è esportato fuori da 'environment')
import { apiUrl } from '../../../../environments/environment';

// 2. IMPORTIAMO IL PAYLOAD DAL PERCORSO GIUSTO (shared)
import { GenerateTestsRequestPayload } from '../../../shared/templateGen/template-api.service';
import { AuthService } from '../../../shared/auth/auth.service';

// Definiamo qui la risposta
export interface BaselineResponse {
  candidates: any[];
  html_table: string;
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class TestGenerationV2Service {

  // Usiamo apiUrl importato direttamente
  private baseUrl = `${apiUrl}/api/v2/tests`;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  private getHeaders(): Observable<HttpHeaders> {
    return this.authService.token$.pipe(
      switchMap(token => {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        return new Observable<HttpHeaders>(observer => {
          observer.next(headers);
          observer.complete();
        });
      })
    );
  }

  /**
   * Genera la Baseline (Veloce + HTML renderizzato)
   */
  generateBaseline(payload: GenerateTestsRequestPayload): Observable<BaselineResponse> {
    return this.http.post<BaselineResponse>(
      `${this.baseUrl}/generate_tests_baseline/`,
      payload
    );
  }

  /**
   * Analizza i Gap (Opzionale)
   */
  analyzeGaps(payload: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/analyze_gaps/`,
      payload
    );
  }

  /**
   * Estende i test con AI (Opzionale)
   */
  generateExtended(payload: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/generate_extended_tests/`,
      payload
    );
  }

  /**
   * NEW: Genera test per un singolo micro-scenario (parallelizzabile)
   */
  generateTestsSingleMicro(payload: any): Observable<{
    candidates: any[];
    count: number;
    micro_id: string;
  }> {
    return this.getHeaders().pipe(
      switchMap(headers =>
        this.http.post<{
          candidates: any[];
          count: number;
          micro_id: string;
        }>(
          `${apiUrl}/api/v2/tests/generate_tests_single_micro/`,
          payload,
          { headers }
        )
      )
    );
  }

  /**
   * NEW: Deduplica e consolida test già generati
   */
  deduplicateTests(payload: {
    candidates: any[];
    dedup_mode?: 'NONE' | 'CROSS_MICRO';
    template_columns?: string[];
    renderer_mode?: 'PY_HTML' | 'JSON_ONLY';
  }): Observable<{
    candidates: any[];
    html_table: string;
    count: number;
    removed_duplicates: number;
  }> {
    return this.getHeaders().pipe(
      switchMap(headers =>
        this.http.post<{
          candidates: any[];
          html_table: string;
          count: number;
          removed_duplicates: number;
        }>(
          `${apiUrl}/api/v2/tests/deduplicate_tests/`,
          payload,
          { headers }
        )
      )
    );
  }
}
